import client from "./client";

const feesApi = {
  list(params = {}) {
    return client.get("/fees/students", { params }).then((r) => r.data);
  },

  getForStudent(studentId) {
    return client.get(`/fees/students/${studentId}`).then((r) => r.data);
  },

  getMyFees() {
    return client.get("/fees/my").then((r) => r.data);
  },

  markPaid(feeId, body) {
    return client.patch(`/fees/${feeId}/mark-paid`, body).then((r) => r.data);
  },

  sendReminders(body) {
    return client.post("/fees/reminders/send", body).then((r) => r.data);
  },

  sendByTier(body) {
    return client.post("/fees/reminders/send-by-tier", body).then((r) => r.data);
  },

  getReminderLog(params = {}) {
    return client.get("/fees/reminders/log", { params }).then((r) => r.data);
  },

  listStructures(params = {}) {
    return client.get("/fee-structures", { params }).then((r) => r.data);
  },

  getStructure(id) {
    return client.get(`/fee-structures/${id}`).then((r) => r.data);
  },

  createStructure(body) {
    return client.post("/fee-structures", body).then((r) => r.data);
  },

  updateStructure(id, body) {
    return client.patch(`/fee-structures/${id}`, body).then((r) => r.data);
  },

  publishStructure(id, body = {}) {
    return client.post(`/fee-structures/${id}/publish`, body).then((r) => r.data);
  },

  archiveStructure(id) {
    return client.post(`/fee-structures/${id}/archive`).then((r) => r.data);
  },

  cloneStructure(id, academicYear) {
    return client.post(`/fee-structures/${id}/clone`, { academicYear }).then((r) => r.data);
  },

  deleteStructure(id) {
    return client.delete(`/fee-structures/${id}`).then((r) => r.data);
  },

  getStudentStructure(studentId) {
    return client.get(`/fee-structures/student/${studentId}`).then((r) => r.data);
  },
};

export default feesApi;
